<template>
  <div class="community-rich-text-editor">
    <div class="toolbar d-flex align-items-center">
      <button
        type="button"
        class="tool"
        title="Negrito"
        @mousedown.prevent="exec('bold')"
      >
        <b>B</b>
      </button>
      <button
        type="button"
        class="tool"
        title="Itálico"
        @mousedown.prevent="exec('italic')"
      >
        <i>I</i>
      </button>
      <button
        type="button"
        class="tool"
        title="Sublinhado"
        @mousedown.prevent="exec('underline')"
      >
        <u>U</u>
      </button>
      <button
        type="button"
        class="tool"
        title="Lista"
        @mousedown.prevent="exec('insertUnorderedList')"
      >
        &bull;
      </button>
      <button
        type="button"
        class="tool"
        title="Lista numerada"
        @mousedown.prevent="exec('insertOrderedList')"
      >
        1.
      </button>
      <button
        type="button"
        class="tool"
        title="Link"
        @mousedown.prevent="createLink"
      >
        <i class="icon-link" />
      </button>
    </div>
    <div
      ref="editor"
      class="editor form-control"
      contenteditable="true"
      :data-placeholder="placeholder"
      @input="onInput"
      @blur="onInput"
    />
  </div>
</template>

<script>
export default {
  name: "RichTextEditor",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Escreva algo..."
    }
  },
  mounted() {
    this.$refs.editor.innerHTML = this.value || "";
  },
  watch: {
    value(newValue) {
      const el = this.$refs.editor;
      if (el && document.activeElement !== el && newValue !== el.innerHTML) {
        el.innerHTML = newValue || "";
      }
    }
  },
  methods: {
    focusEditor() {
      this.$refs.editor.focus();
    },
    exec(command) {
      document.execCommand(command, false, null);
      this.focusEditor();
      this.onInput();
    },
    createLink() {
      const url = window.prompt("Endereço do link (https://...)");
      if (!url) return;
      const trimmed = url.trim();
      if (!/^(https?:|mailto:)/i.test(trimmed)) {
        this.$message.error(
          "Use um link começando com http://, https:// ou mailto:"
        );
        return;
      }
      this.focusEditor();
      document.execCommand("createLink", false, trimmed);
      this.onInput();
    },
    isEmpty(html) {
      const text = html
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, "")
        .trim();
      return !text;
    },
    onInput() {
      const html = this.$refs.editor.innerHTML;
      this.$emit("input", this.isEmpty(html) ? "" : html);
    }
  }
};
</script>

<style lang="scss" scoped>
.community-rich-text-editor {
  .toolbar {
    gap: 4px;
    margin-bottom: 8px;

    .tool {
      min-width: 32px;
      height: 32px;
      border: 1px solid rgba(128, 128, 128, 0.3);
      border-radius: 6px;
      background: transparent;
      color: inherit;
      font-size: 14px;
      line-height: 1;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      i {
        font-size: 16px;
      }
    }
  }

  .editor {
    min-height: 96px;
    height: auto;
    border-radius: 10px;
    padding: 12px 16px;
    overflow-y: auto;
    text-align: left;

    &:empty:before {
      content: attr(data-placeholder);
      opacity: 0.6;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
